import { toast } from "../toast/toast";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Reagent } from "../../../backend/src/types";
import LoadingOverlay from "../components/Loading";
import InfoTab from "../components/tabs/InfoTab";
import LogTab from "../components/tabs/LogTab";
import { useUser } from "../contexts/UserContext";
import { getReagentListByIds } from "../fetch/AlertRequest";
import styles from "../styles/modules/ReagentPage.module.css";
import "../styles/sanitize.css";

function ReagentsDetailPage() {
  const { units, userLabs } = useUser();
  const { id } = useParams<{ id: string }>();
  const [reagent, setReagent] = useState<Reagent | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLogTab, setIsLogTab] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (id) loadReagent(id);
  }, [id]);

  async function loadReagent(id: string) {
    const reagent_id = Number(id);

    if (isNaN(reagent_id)) {
      toast.error("試薬idの取得に失敗しました:不正なURLです。");
      navigate("/reagents");
      return;
    }

    const payload: number[] = [reagent_id];
    const reagents = await getReagentListByIds({ ids: payload });

    if (reagents.length === 1) {
      const targetReagent = reagents[0];

      const isUserLab = userLabs.some((lab) => lab.id === targetReagent.lab_id);

      if (!isUserLab) {
        toast.error("このページを表示する権限がありません。");
        navigate("/reagents");
        return;
      }

      setReagent(targetReagent);
    } else {
      toast.error("URLに対応するidを持つ試薬が見つかりませんでした。");
      navigate("/reagents");
    }
  }

  return (
    <>
      <div className={styles["reagent-detail-page"]}>
        {reagent && (
          <button
            className={styles["back-link"]}
            onClick={() =>
              navigate(`/reagents/group/${reagent.group_id}`, {
                state: { labId: reagent.lab_id },
              })
            }
          >
            ← 試薬一覧
          </button>
        )}
        <h2>試薬管理</h2>
        <div className={styles["tab-toggle"]}>
          <button
            type="button"
            onClick={() => setIsLogTab(false)}
            className={!isLogTab ? styles["active"] : undefined}
          >
            情報
          </button>
          <button
            type="button"
            onClick={() => setIsLogTab(true)}
            className={isLogTab ? styles["active"] : undefined}
          >
            履歴
          </button>
        </div>
        {!isLogTab && reagent && (
          <InfoTab
            reagent={reagent}
            units={units}
            setReagent={setReagent}
            onLoading={setIsLoading}
            reloadReagent={loadReagent}
          />
        )}
        {isLogTab && reagent && (
          <LogTab reagent={reagent} units={units} onLoading={setIsLoading} />
        )}
      </div>
      {isLoading && <LoadingOverlay />}
    </>
  );
}

export default ReagentsDetailPage;
